module.exports = __webpack_public_path__ + "static/media/17.257f64db.jfif";